import React from 'react';

const initialState = {
	teamLoading: false,
	teamRoaster: [],
	teamRoasterById: [],
	teamRosterByTeamId: [],
	error: null,
};

const TeamRosterReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'ADD_TEAM_LOADER':
			return {
				...state,
				teamLoading: action.payload,
			};
		case 'GET_ROSTER':
			return {
				...state,
				teamRoaster: action.payload,
			};
		case 'GET_ROSTER_BY_ID':
			return {
				...state,
				teamRoasterById: action.payload,
			};
		case 'GET_ROSTER_BY_TEAM_ID':
			return {
				...state,
				teamRosterByTeamId: action.payload,
			};
		default:
			return state;
	}
};
export default TeamRosterReducer;
